import { render, staticRenderFns } from "./PositionChange.vue?vue&type=template&id=07b01a72&scoped=true"
import script from "./PositionChange.vue?vue&type=script&lang=js"
export * from "./PositionChange.vue?vue&type=script&lang=js"
import style0 from "./PositionChange.vue?vue&type=style&index=0&id=07b01a72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b01a72",
  null
  
)

export default component.exports